import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { CorpSearchListDto } from "../dto/SearchList.dto";
import { useQuery } from "react-query";

export const fetchData = async (params: string): Promise<CorpSearchListDto[]> => {
    try {
        const response = await axiosInstance.get(`${axiosPath.corpSearchList}?query=${params}`);

        return response.data.list || [];
    } catch (error) {
        console.error("Error fetching search address data: ", error);
        throw error;
    }
};

export const useCorpSearchList = (query: string) => {
    return useQuery(["corpSearchList", query], () => fetchData(query), {
        enabled: false,
        retry: 0,
        onError: (error) => {
            console.error(error);
        },
    });
};
